export function downloadFile(path, getResourceUrl) {
  if (!path) {
    alert("다운로드할 파일이 없습니다.");
    return;
  }
  const fullUrl = getResourceUrl(path);
  const fileName = path.split("/").pop();
  fetch(fullUrl)
    .then((response) => response.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    })
    .catch((error) => {
      console.error("다운로드 실패:", error);
      alert("파일 다운로드에 실패했습니다.");
    });
}

// SheetJS 라이브러리를 동적으로 로드하는 함수
let sheetJSLoaded = false;
async function loadSheetJS() {
  if (sheetJSLoaded) return;
  
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js';
    script.onload = () => {
      sheetJSLoaded = true;
      resolve();
    };
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

// 엑셀 다운로드 함수
export async function downloadExcel(data, fileName = 'export.xlsx') {
  try {
    await loadSheetJS();
    
    if (!window.XLSX) {
      throw new Error('XLSX 라이브러리 로드 실패');
    }

    const workbook = window.XLSX.utils.book_new();
    
    // 데이터가 객체 형태인 경우 (분류별로 시트 생성)
    if (typeof data === 'object' && !Array.isArray(data)) {
      Object.keys(data).forEach(sheetName => {
        const worksheet = window.XLSX.utils.json_to_sheet(data[sheetName]);
        window.XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
      });
    } else {
      // 단일 배열인 경우
      const worksheet = window.XLSX.utils.json_to_sheet(data);
      window.XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
    }
    
    // 엑셀 파일 생성 및 다운로드
    window.XLSX.writeFile(workbook, fileName);
    
  } catch (error) {
    console.error('엑셀 다운로드 실패:', error);
    alert('엑셀 다운로드에 실패했습니다.');
  }
}